import { render, staticRenderFns } from "./fsTableFoot.vue?vue&type=template&id=6095c897"
import script from "./fsTableFoot.vue?vue&type=script&lang=js"
export * from "./fsTableFoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports